// Componentes del módulo de inventario
const ProductsList = () => import('@/components/inventario/productos/Products-list.vue');
const NuevoProducto = () => import('@/components/inventario/productos/Edit-modal.vue');
const CategoriasInventario = () => import('@/components/inventario/categorias-de-inventario/Categorias-de-inventario.vue');
const CategoriasInventarioV2 = () => import('@/components/inventario/categorias-de-inventario/CategoriasInventarioV2.vue');
const MarcasProductos = () => import('@/components/inventario/marcas-de-productos/Marcas-de-productos.vue');
const ExistenciaStock = () => import('@/components/inventario/existencias-en-stock/existencia-en-stock.vue');
const ConsultaPrecio = () => import('@/components/inventario/consulta-de-precio/consulta-de-precio.vue');
const MovimientoStock = () => import('@/components/inventario/movimientos-de-stock/Movimiento-de-stock.vue');
const ActualizarPrecios = () => import('@/components/inventario/actualizar-precios/Actualizar-precios.vue');
const ListasPrecios = () => import('@/components/inventario/listas-de-precios/Lista-de-precios.vue');
const Importexcel = () => import('@/components/inventario/productos/Importexcel.vue');
const Depositos = () => import('@/components/inventario/depositos/Depositos.vue');
const SerialNumbers = () => import('@/components/inventario/productos/numeros-de-serie/SerialNumbers.vue');

const inventory = {
  path: '/inventario',
  redirect: '/inventario/productos',
  children: [
    // Productos
    {
      path: 'productos',
      name: 'Inventario',
      component: ProductsList,
      // Acepta ?categoria=<id> para entrar filtrado desde el árbol de
      // categorías. Con props: true el prop nunca llegaba, porque el path
      // no declara ningún param.
      props: route => ({ categoryId: route.query.categoria || null }),
      meta: { title: 'Inventario de Productos' },
    },
    {
      path: 'importar',
      name: 'Importexcel',
      component: Importexcel,
      meta: { title: 'Importar Productos desde CSV' },
    },
    {
      path: 'productos/nuevo',
      name: 'Nuevo producto',
      component: NuevoProducto,
      meta: { title: 'Nuevo Producto' },
    },
    {
      path: 'productos/:productId/editar',
      name: 'Editar producto',
      component: NuevoProducto,
      props: true,
      meta: { title: 'Editar Producto' },
    },
    {
      path: 'productos/:productId/numeros-de-serie',
      name: 'Numeros de serie',
      component: SerialNumbers,
      props: true,
      meta: { title: 'Números de Serie' },
    },

    // Categorías y Marcas
    {
      path: 'categorias',
      name: 'Categorias de inventario',
      component: CategoriasInventario,
      meta: { title: 'Categorías de Inventario' },
    },
    {
      path: 'categorias-arbol',
      name: 'Categorias de inventario V2',
      component: CategoriasInventarioV2,
      meta: { title: 'Categorías de Inventario (Árbol)' },
    },
    {
      path: 'marcas',
      name: 'Marcas de productos',
      component: MarcasProductos,
      meta: { title: 'Marcas de Productos' },
    },

    // Stock
    {
      path: 'stock',
      name: 'Existencias en stock',
      component: ExistenciaStock,
      meta: { title: 'Existencias en Stock' },
    },
    {
      // Acepta ?producto=<id> para entrar filtrada por un producto, y
      // ?accion=movimiento|transferencia para abrir directo ese formulario.
      // Antes esperaba params de path (:productId/:modal) que ninguna ruta
      // declaraba, así que llegar acá desde un producto no funcionaba y la
      // pantalla se abría siempre vacía.
      path: 'movimientos',
      name: 'Movimientos de stock',
      component: MovimientoStock,
      props: route => ({ productIdParent: route.query.producto || null }),
      meta: { title: 'Movimientos de Stock' },
    },

    // Precios
    {
      path: 'consulta-precios',
      name: 'Consulta de Precio',
      component: ConsultaPrecio,
      meta: { title: 'Consulta de Precios' },
    },
    {
      path: 'actualizar-precios',
      name: 'Actualizacion de precios',
      component: ActualizarPrecios,
      meta: { title: 'Actualización de Precios' },
    },
    {
      path: 'listas-precios',
      name: 'Listas de precios',
      component: ListasPrecios,
      meta: { title: 'Listas de Precios' },
    },

    // Depósitos
    {
      path: 'depositos',
      name: 'Depositos',
      component: Depositos,
      meta: { title: 'Depósitos' },
    },

  ],
};

export default inventory;
